import * as React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

import Pin_Disposal from '../../images/Icon_Disposal.png'
import Pin_HealthClinic from '../../images/Icon_HealthClinic.png'
import Pin_HIV from '../../images/Icon_HIV.png'
import Pin_Pharmacy from '../../images/Icon_Pharmacy.png'
import Pin_Recovery from '../../images/Icon_Recovery.png'
import Pin_Syringe from '../../images/Icon_Syringe.png'

function categoryToPin(category) {
    switch(category) {
        case "Pharmacy":
            return Pin_Pharmacy;
        case "Substance Use Disorder Treatment":
            return Pin_Recovery;
        case "Sharps Disposal":
            return Pin_Disposal;
        case "Health Clinic":
            return Pin_HealthClinic;
        case "HIV Services":
            return Pin_HIV;
        case "Syringe Exchange":
            return Pin_Syringe;
    }
    return Pin_HealthClinic
}

const categories = ['View All', 'Pharmacy', 'Substance Use Disorder Treatment', 'Sharps Disposal', 'Health Clinic', 'HIV Services', 'Syringe Exchange'];

export default function InitialCategoryDialog(props) {
  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>What are you looking for?</DialogTitle>
      <List sx={{ pt: 0 }}>
        {categories.map((category) => (
          <ListItem button onClick={() => handleListItemClick(category)} key={category}>
            <ListItemAvatar>
                <Avatar src={categoryToPin(category)} />
            </ListItemAvatar>
            <ListItemText primary={category} />
          </ListItem>
        ))}
      </List>
    </Dialog>
  );
}

InitialCategoryDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};
